<template>
  <div
    class="tags-filter">
    <span
      v-if="text"
      class="margin-right-m">
      {{ text }}
    </span>
    <span
      v-else
      class="margin-right-m">
      {{ $t('variables.filter') }}
    </span>
    <treeselect
      v-bind:style="{ width: selectWidth }"
      v-on:input="onInput"
      :value="value"
      value-consists-of="LEAF_PRIORITY"
      :multiple="true"
      :options="getTreeOptions()"/>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';

export default {
  name: 'TagsFilter',
  components: {
    Treeselect
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    tagsTree: {
      type: Array,
      default: () => []
    },
    text: {
      type: String,
      default: undefined
    },
    selectWidth: {
      type: String,
      default: '16rem'
    }
  },
  methods: {
    getTreeOptions () {
      return createOptions(this.tagsTree);
    },
    onInput (ids) {
      this.$emit('input', ids);
    }
  }
};

const createOptions = (nodes) => {
  const options = [];
  for (let i = 0; i < nodes.length; i++) {
    const option = {
      id: nodes[i].data.id,
      label: nodes[i].text
    };

    if (nodes[i].children.length > 0) {
      option.children = createOptions(nodes[i].children);
    }

    options.push(option);
  }

  return options;
};

</script>

<style lang="scss" scoped>
  @import "../../stylesheets/variables.scss";

  .tags-filter {
    display: flex;
    align-items: center;
    margin-left: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/variable/TagsFilter.vue